import dhtmlXLayoutObject from './dhtmlXLayoutObject';
import './dhtmlXCellObjectExtend.js';

export default dhtmlXLayoutObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/index.js